module.exports = __webpack_public_path__ + "static/media/Ciclo full.9eaf26d1.png";